import React,  { useState } from 'react';
import { find, sum } from 'lodash';
import ReactTable from 'react-table';
import Box from '../../common/Box';
import IncrementalLineChart from '../../widgets/charts/types/IncrementalLineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import countriesByAbbreviation from '../../common/CountriesByAbbreviation';
import CSV from '../../../helpers/CSVExport';
import { splitByThousands } from '../../../helpers/NumberFormatter';

var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');

const toolbarChartViewIcons = {
		table: tableSvg,
		pie: pieSvg,
		bar: barSvg
}

export default function SourcesRatio(props) {
	const [mode, setMode] = useState('bar');
	
	const { table = [] } = props;
	const { period, physical_ratio, digital_ratio, loading } = props.results || {};
	
	const getTimeseries = () => {
		return  {
			labels: period,
			datasets: [
				{label: 'Physical', data: physical_ratio, backgroundColor: "#3466CB", borderColor: "#3466CB"},
				{label: 'Digital', data: digital_ratio, backgroundColor: "#FF9900", borderColor: "#FF9900"},
			]
		};
	}
	
	const exportToCsv = () => {
		let data = table.map(row => {
		  return {
			period: row.period,
			physical: row.physical_ratio,
			digital: row.digital_ratio,
		  };
		});
		const filename = CSV.CSVHeader('revenue_streams_share', ''); 
		return CSV.CSVExport(data, {filename}, 'revenue_streams_share');
	}

	
	const getPie = () => {
		let dataset = [
			Math.round(sum(physical_ratio) / physical_ratio.length),
			Math.round(sum(digital_ratio) / digital_ratio.length),
		], 
		
		labels = ['Physical Ratio', 'Digital Ratio'];
		console.log(dataset);
		return {
			labels: labels,
			datasets: [{
				data: dataset, label: 'revenue', backgroundColor: ["#3466CB", "#FF9900"]
			}]
		};		
	}
	
	const getTable = () => {
		const commonColumnProps = {
			// className: 'table-text-right', 
			// headerClassName: 'table-text-right',
		};
		let columns = [
			{
				id: 'period',
				accessor: 'period',
				Header: 'Period',
				...commonColumnProps
			},
			{
				id: 'physical_ratio',
				accessor: 'physical_ratio',
				Header: 'Physical Ratio',
				Cell: props => <span>{props.value}%</span>,
				...commonColumnProps
			},
			{
				id: 'digital_ratio',
				accessor: 'digital_ratio',
				Header: 'Digital Ratio',
				Cell: props => <span>{props.value}%</span>,
				...commonColumnProps
			},
		];
		return <ReactTable 
			className=""
			data={table} 
			columns={columns}
			defaultPageSize={10}
			showPagination={true}        	
		/>
	}
	
	const renderToolbar = () => {
		let toolbar = [];
		let views = {
			'table': 'table',
			'bar': 'chart-bar',
			'pie': 'chart-pie'
		}
		for (let view in views) {
			toolbar.push(<a key={view} className={`chart-icon ${mode == view? 'active' : ''}`} onClick={()=>setMode(view)} dangerouslySetInnerHTML={{__html: toolbarChartViewIcons[view]}}></a>);
		}
		toolbar.push(<a key='download' className="chart-icon" onClick={()=>exportToCsv()} dangerouslySetInnerHTML={{__html: downloadSvg}}></a>);
		return toolbar;
	}


	
	return <Box title={`Physical vs. Digital`} spinnerEnabled={loading} toolbar={renderToolbar()}>
		{period && <div className="chart-block">
			{mode == 'bar' && <StackedBarChart data={getTimeseries()} isCustomWidth={true} options={{
				"legend": {"position": "bottom",
					"labels": {
						"fontFamily": "Ubuntu",
						"fontSize": 16,
						"padding": 20,
						"boxWidth": 10,
					}
				}, 
				"barPercentage": 0.9, 
				"layout": {
					"padding": {
						"top": 20,
					}
        },
				"tooltips": {
					"callbacks": {
						"label": (tooltipItem, data) => {
							var dataLabel = data.datasets[tooltipItem.datasetIndex].label,
								value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
							return `${dataLabel}: ${splitByThousands(value)}%`;
						}
					}    
				},
				scales: {
					yAxes: [{
							gridLines: {
									drawOnChartArea: false
							},
							scaleLabel: {
									display: true,
									labelString: "% of Revenue ",
									fontSize: 16
							},
					}],
					xAxes: [{
							gridLines: {
									drawOnChartArea: false
							}
					}]
				}
			}} 
			chartID="territories_report_sources_ratio_chart" />}
			{mode == 'pie' && <DoughnutChart data={getPie()} options={{
				"legend": {
					"display": true,
					"position": "bottom",
					"labels": {
						"fontFamily": "Ubuntu",
						"fontSize": 16,
						"padding": 20,
						"boxWidth": 10,
					}
				},
				"tooltips": {
					"callbacks": {
						"label": (tooltipItem, data)=>{
							var dataLabel = data.labels[tooltipItem.index],
								value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
							return `${dataLabel}: ${splitByThousands(value)}%`;
						}
					}    
				},
			}} chartID="territories_report_sources_ratio_chart" />}
			{mode == 'table' && getTable()}
		</div>}
	</Box>
}